import type { TrackedAccessory } from 'common/types/accessory-slider';
import type { Product } from 'common/types/product-card';

const mapDelivery = (delivery: TrackedAccessory['delivery']): Product['delivery'] =>
  delivery
    ? {
        flags: delivery.flags ? { fastDelivery: delivery.flags.fastDelivery } : null,
        time: delivery.time,
      }
    : null;

export const accessoryToProduct = (accessory: TrackedAccessory) => ({
  sku: accessory.sku,
  parentSku: accessory.parentSku,
  name: accessory.name,
  variantName: accessory.variantName,
  url: accessory.url,
  trackingId: accessory.trackingId,
  labels_v2: accessory.labels_v2 ?? [],
  prices: accessory.prices,
  delivery: mapDelivery(accessory.delivery),
  breadcrumbs: accessory.breadcrumbs ?? [],
  campaigns: (accessory.campaigns ?? null) as Product['campaigns'],
  energyClass: accessory.energyClass,
  images: accessory.images,
  ratings: accessory.ratings ?? { count: 0, average: 0 },
  brand: accessory.brand?.name ? { name: accessory.brand.name } : null,
  sponsored: accessory.sponsored ?? null,
  variations: accessory.variations ?? null,
  tracking: accessory.tracking,
  bestOffer: accessory.bestOffer ?? { isHome24: true, shop: null },
  metrics: accessory.metrics ?? { wishlist: { count: 0, parentCount: 0 } },
  variationsMinPrice: accessory.variationsMinPrice,
});
